import toast from "react-hot-toast"
import { apiConnector } from "../apiConnector"
import { apiClient } from "../apiClient"
import { setdevices } from '../../slices/devices'
import { Get_Managers_User } from "./Users"

// Helper to get role
const getRole = () => {
    const user = localStorage.getItem('user')
    const userData = user ? JSON.parse(user) : null
    return userData?.role
}

//MANAGER API CALLING FUNCTION LOGIC.
export function Get_Devices(token) {
    return async (dispatch) => {
        try {
            const response = await apiConnector("GET", apiClient.GET_DEVICE, null, {
                Authorization: `Bearer ${token}`
            })
            if (!response.data.success) {
                throw new Error(response.data.message)
            }
            dispatch(setdevices(response.data.device_data))
            //localStorage.setItem('devices',JSON.stringify(response.data.data))
            toast.success(response.data.message)
            return response
        } catch (error) {
            const message = error.response?.data?.message||error.message
            console.log("Error In Get_Devices Function:", message)
            toast.error(message)
            return error.response
        }
    }
}

export function Update_Devices(formData) {
    const token = localStorage.getItem('token')
    return async (dispatch) => {
        try {
            const response = await apiConnector("PUT", apiClient.UPDATE_DEVICE + `/${formData._id}`, formData, {
                Authorization: `Bearer ${token}`
            })
            if (!response.data.success) {
                throw new Error(response.data.message)
            }
            dispatch(Get_Devices(token))
            toast.success(response.data.message)
            return response
        } catch (error) {
            const message = error.response?.data?.message||error.response
            console.log("Error In Update_Devices Function:", message)
            toast.error(message)
            return error.response
        }
    }
}
export function Create_Devices(formData) {
    console.log("formdata devices...", formData);
    const token = localStorage.getItem('token')
    return async (dispatch) => {
        try {
            const response = await apiConnector("POST", apiClient.CREATE_DEVICE, formData, {
                Authorization: `Bearer ${token}`
            })
            if (!response.data.success) {
                console.log("Add Device:", response.data.message)
                throw new Error(response.data.message)
            }
            dispatch(Get_Devices(token))
            toast.success(response.data.message)
            return response
        } catch (error) {
            const message = error.response?.data?.message || error.message;
            console.log("Error In Create_Devices:", message);
            toast.error(message);
            return error.response
        }
    }
}
export function Delete_Devices(_id) {
    const token = localStorage.getItem('token')
    return async (dispatch) => {
        try {
            const response = await apiConnector("DELETE", apiClient.DELETE_DEVICE + `/${_id}`, null, {
                Authorization: `Bearer ${token}`
            })
            if (!response.data.success) {
                throw new Error(response.data.message)
            }
            dispatch(Get_Devices(token))
            dispatch(Get_Managers_User(token))
            toast.success(response.data.message)
            return response
        } catch (error) {
            console.log("Error In Get_Devices Function:", error.message)
            toast.error(error.message)
            return error.response
        }
    }
}
export function Unenroll_Users_From_device(_id){
    const token = localStorage.getItem('token')
    const role = getRole()
    return async(dispatch)=>{
        try {
            // const response = await apiConnector("GET",apiClient.UNENROLLED_USER_FROM_DEVICE + `/${_id}`,null,{
            //     Authorization:`Bearer ${token}`
            // })
            const url = role === "Organization"
                ? apiClient.REMOVE_FINGERPRINT_FROM_DEVICE + `/${_id}`
                : apiClient.UNENROLLED_USER_FROM_DEVICE + `/${_id}`

            console.log("unenroll_user | Role:", role, "| URL:", url)

            const response = await apiConnector("GET", url, null, {
                Authorization: `Bearer ${token}`
            })
            if(!response.data.success){
                throw new Error(response.data.message)
            }
            dispatch(Get_Managers_User(token))
            toast.success(response.data.message)
            return response
        } catch (error) {
            const message = error.response?.data?.message || error.message;
            console.log("Error In Unenroll:",message)
            toast.error(message)
            return error.response
        }
    }
}

export function Delete_Users_From_device(_id){
    const token = localStorage.getItem('token')
    const role = getRole()
    return async(dispatch)=>{
        try {
            // const response = await apiConnector("GET",apiClient.DELETE_USER_FROM_DEVICE + `/${_id}`,null ,{
            //     Authorization:`Bearer ${token}`
            // })
            const url = role === "Organization"
                ? apiClient.DELETE_USER_FROM_DEVICE_ORG + `/${_id}`
                : apiClient.DELETE_USER_FROM_DEVICE + `/${_id}`

            const response = await apiConnector("GET", url, null, {
                Authorization: `Bearer ${token}`
            })
            if(!response.data.success){
                throw new Error(response.data.message)
            }

            toast.success(response.data.message)
            return response
            
        } catch (error) {
            const message = error.response?.data?.message || error.message
            console.log("Error In Delete Users From Device:",message)
            toast.error(message)
            return error.response
        }
    }
}

// ORGANIZATION DEVICE APIs
export function Get_Org_Devices(token) {
    return async (dispatch) => {
        try {
            const response = await apiConnector("GET", apiClient.GET_DEVICE_ORG, null, {
                Authorization: `Bearer ${token}`
            })
            console.log("Get Org Devices Response:", response)
            if (!response.data.success) {
                throw new Error(response.data.message)
            }
            dispatch(setdevices(response.data.data))
            toast.success(response.data.message)
            return response
        } catch (error) {
            console.log("Error In Get Org Devices Function:", error.message)
            toast.error(error.message)
            return error.response
        }
    }
}
export function Create_Org_Device(formData) {
    const token = localStorage.getItem('token')
    console.log("formdata...", formData);
    return async (dispatch) => {
        try {
            const response = await apiConnector("POST", apiClient.CREATE_DEVICE_ORG, formData, {
                Authorization: `Bearer ${token}`
            })
            console.log("reponse from api...", response);
            if (!response.data.success) {
                console.log("Create Org Device:", response.data.message)
                throw new Error(response.data.message)
            }
            dispatch(Get_Org_Devices(token))
            toast.success(response.data.message)
            return response
        } catch (error) {
            const message = error.response?.data?.message || error.message;
            console.log("Error In Create Org Device:", message);
            toast.error(message);
            return error.response
        }
    }
}
export function Update_Org_Device(deviceId, formData) {
    console.log("formdata update..", formData)
    const token = localStorage.getItem('token')
    return async (dispatch) => {
        try {
            const response = await apiConnector("PUT", apiClient.UPDATE_DEVICE_ORG + `/${deviceId}`, formData, {
                Authorization: `Bearer ${token}`
            })
            if (!response.data.success) {
                throw new Error(response.data.message)
            }
            dispatch(Get_Org_Devices(token))
            toast.success(response.data.message)
            return response
        } catch (error) {
            const message = error.response?.data?.message || error.message
            console.log("Error In Update Org Device Function:", message)
            toast.error(message)
            return error.response
        }
    }
}
export function Delete_Org_Device(deviceId) {
    const token = localStorage.getItem('token')
    return async (dispatch) => {
        try {
            const response = await apiConnector("DELETE", apiClient.DELETE_DEVICE_ORG + `/${deviceId}`, null, {
                Authorization: `Bearer ${token}`
            })
            if (!response.data.success) {
                throw new Error(response.data.message)
            }
            dispatch(Get_Org_Devices(token))
            toast.success(response.data.message)
            return response
        } catch (error) {
            console.log("Error In Delete Org Device Function:", error.message)
            toast.error(error.message)
            return error.response
        }
    }
}

// get device history
export function Get_Device_History(deviceId) {
    const token = localStorage.getItem('token')
    const role = getRole()
    return async (dispatch) => {
        try {
            const url = role === "Organization"
                ? apiClient.GET_DEVICE_HISTORY_ORG + `/${deviceId}`
                : apiClient.GET_DEVICE_HISTORY_MNG + `/${deviceId}`
            const response = await apiConnector("GET", url, null, {
                Authorization: `Bearer ${token}`
            })
            if (!response.data.success) {
                throw new Error(response.data.message)
            }
            dispatch(Get_Org_Devices(token))
            //localStorage.setItem('devices',JSON.stringify(response.data.data))
            toast.success(response.data.message)
            return response
        } catch (error) {
            const message = error.response?.data?.message||error.message
            console.log("Error In Function:", message)
            toast.error(message)
            return error.response
        }
    }
}
